import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./collections.html";
import Icon from '@oneappexchange/appx-design-system/modules/ax/icon/icon';
import { WORDPRESS_SERVICE_URL } from '~/modules/config';
import { htmlDecode, loadWordPressScript } from '~/modules/helpers/wordPressHelper';
import { initialPageRenderedMetricsCheck } from '~/modules/services/metricsService';
import { selectCurrentContentItem, wordPressStore } from '~/modules/stores/wordpress_store';
Icon.defaultSpriteUrl = '';
import '../../../mfes/cmsElements';
import '../../../mfes/cmsElementsDynamic';
const HEADER_HEIGHT = 205;
const removeHashFromWindow = () => {
  if (window.location.hash) {
    window.history.replaceState(null, '', ' ');
  }
};
class Collections extends LightningElement {
  constructor(...args) {
    super(...args);
    this.firstRendered = false;
    this.isLoading = true;
    this.isError = false;
    this.scrollToHash = () => {
      const hash = window.location.hash;
      if (!hash) {
        return;
      }
      removeHashFromWindow();
      const el = this.refs?.container?.querySelector(hash);
      if (el) {
        const top = el?.getBoundingClientRect().top + window.scrollY - HEADER_HEIGHT;
        window.scroll({
          top,
          behavior: 'instant'
        });
      }
    };
  }
  updateCmsContent() {
    const cmsState = wordPressStore.getState();
    const currentContent = selectCurrentContentItem(cmsState);
    if (currentContent) {
      this.isError = currentContent.isError;
      this.isLoading = currentContent.isLoading;
      const container = this.template.querySelector('div');
      if (container) {
        if (!currentContent.isError && !currentContent.isLoading) {
          const stylesheet = document.createElement('link');
          stylesheet.setAttribute('rel', 'stylesheet');
          stylesheet.setAttribute('href', `${WORDPRESS_SERVICE_URL}/wp-content/themes/appexchange/dist/css/frontend.css`);
          const renderedContent = currentContent.data?.content?.rendered ? htmlDecode(currentContent.data.content.rendered) : '';

          // eslint-disable-next-line @lwc/lwc/no-inner-html
          container.innerHTML = renderedContent;
          container.appendChild(stylesheet);

          // Add WP container classes
          container.classList.add('axwp-content');
          container.classList.add('axwp-content__collection');
        } else {
          // eslint-disable-next-line @lwc/lwc/no-inner-html
          container.innerHTML = '';
        }
      }
    }
  }
  connectedCallback() {
    loadWordPressScript();
    window.addEventListener('hashchange', this._hashChangeHandler = this.scrollToHash);
  }
  disconnectedCallback() {
    if (this._hashChangeHandler) {
      window.removeEventListener('hashchange', this._hashChangeHandler);
    }
  }
  handleLinkClick(ev) {
    const target = ev.target;
    if (target.tagName !== 'A') {
      return;
    }
    // Push to dataLayer for GA4
    const analyticsEvent = new CustomEvent('analytics', {
      bubbles: true,
      composed: true,
      detail: {
        elementType: 'link',
        eventType: 'click',
        link: {
          callToAction: {
            url: target.href,
            label: target.textContent,
            name: target.textContent
          }
        }
      }
    });
    this.dispatchEvent(analyticsEvent);
  }
  renderedCallback() {
    removeHashFromWindow();

    // This handles the case of data already being available via server side fetch
    if (!this.firstRendered) {
      this.updateCmsContent();

      //GA4 Coverage for Collections page[WP pages]
      this.template?.addEventListener('click', this.handleLinkClick);
      initialPageRenderedMetricsCheck();
      this.firstRendered = true;
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Collections, {
  fields: ["firstRendered", "isLoading", "isError", "scrollToHash"]
});
const __lwc_component_class_internal = _registerComponent(Collections, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;